import { ResponseType } from "../../../Types/ServicesType/servicesType";
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";
const {clinicId,createdById} = getConstants()
import {
  CptListType,
  LabListType,
  MasterDataType,
  MasterTableDataType,
  SaveResponseType,
  SearchParamsType,
  TemplateFieldType,
} from "./types";

const { MastersApi } = api;
export const getMastersTableData = async (
  params: SearchParamsType
): Promise<
  ResponseType<{
    observationTemplateList: MasterTableDataType[];
    totalRecords: number;
  }>
> => {
  const result = await instance.post(
    `${MastersApi.getAllObservationTemplate}`,
    { ...params, clinicId }
  );
  return result.data;
};

export const saveMasterData = async (
  params: MasterDataType
): Promise<ResponseType<SaveResponseType>> => {
  const result = await instance.post(`${MastersApi.observationTemplateSave}`, {...params,clinicId,createdById});
  return result.data;
};

export const updateTemplateStatus = async (params: {
  templateId: number[];
  status: number;
}): Promise<ResponseType<string>> => {
  const result = await instance.post(
    `${MastersApi.updateObservationTemplateStatus}`,
    { ...params, clinicId }
  );
  return result.data;
};

export const getAllCpt = async (
  search: string
): Promise<ResponseType<CptListType[]>> => {
  const result = await instance.post(`${MastersApi.observationCpt}`, {
    search,
    clinicId,
  });
  return result.data;
};

export const getAllLoinc = async (
  search: string
): Promise<ResponseType<CptListType[]>> => {
  const result = await instance.post(`${MastersApi.observationLoincCodes}`, {
    search,
    clinicId,
  });
  return result.data;
};

export const getAllFields = async (params: {
  templateName: string;
  cptId: number;
}): Promise<ResponseType<TemplateFieldType[]>> => {
    const result = await instance.post(`${MastersApi.observationTemplateFields}`, {
    ...params,
    clinicId,
  });
  return result.data;
};

export const getAllLabs = async (search:string): Promise<ResponseType<LabListType[]>> => {
    const result = await instance.post(`${MastersApi.observationLablist}`, {
    search,
    clinicId,
  });
  return result.data;
};
